import { apiClient } from '@/lib/api/client';
import { getDataOrThrowApiError } from '@/lib/api/error';
import type { CompleteDraftCatalogFileUploadRequest, GetDraftCatalogFilePresignedUrlResponse, GetDraftCatalogHeaderResponse, GetDraftCatalogResponse, SaveDraftCatalogRequest } from './type';

/**
 * Draft デバイスカタログ情報取得
 */
export async function getDraftCatalog(id: string): Promise<GetDraftCatalogResponse> {
  const res = await apiClient.GET('/v2/device-catalogs/draft/{id}', {
    params: {
      path: {
        id
      }
    }
  });
  return getDataOrThrowApiError(res);
}

/**
 * Draft デバイスカタログ情報更新
 */
export async function saveDraftCatalog(id: string, data: SaveDraftCatalogRequest): Promise<void> {
  const res = await apiClient.POST('/v2/device-catalogs/draft/{id}', {
    params: {
      path: {
        id
      }
    },
    body: data
  });
  getDataOrThrowApiError(res);
}

/**
 * Draft デバイスカタログ ヘッダー情報取得
 */
export async function getDraftCatalogHeader(id: string): Promise<GetDraftCatalogHeaderResponse> {
  const res = await apiClient.GET('/v2/device-catalogs/draft/{id}/profile-header', {
    params: {
      path: {
        id
      }
    }
  });
  return getDataOrThrowApiError(res);
}

/**
 * Draft デバイスカタログを削除
 */
export async function deleteDraftCatalog(id: string): Promise<void> {
  const res = await apiClient.DELETE('/v2/device-catalogs/draft/{id}', {
    params: {
      path: {
        id
      }
    }
  });
  getDataOrThrowApiError(res);
}

/**
 * Draft カタログファイル Presigned URL取得
 */
export async function getDraftCatalogFilePresignedUrl(id: string): Promise<GetDraftCatalogFilePresignedUrlResponse> {
  const res = await apiClient.POST('/v2/device-catalogs/draft/{id}/files/presigned-url', {
    params: {
      path: {
        id
      }
    }
  });
  return getDataOrThrowApiError(res);
}

/**
 * Draft カタログファイルアップロード完了通知
 */
export async function completeDraftCatalogFileUpload(id: string, params: CompleteDraftCatalogFileUploadRequest): Promise<void> {
  const res = await apiClient.POST('/v2/device-catalogs/draft/{id}/files/complete', {
    params: {
      path: {
        id
      }
    },
    body: params
  });
  getDataOrThrowApiError(res);
}